const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';
export class InvoicesParser {
  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      default:
        error = UNKNOWN_ERROR_MESSAGE;
    }
    return error;
  };
}
